import React, { createContext, useContext, useReducer } from "react";

export const ProjectContext = createContext(null);
export const ProjectProvider = ({ reducer, initialState, children }) => (
  <ProjectContext.Provider value={useReducer(reducer, initialState)}>
    {children}
  </ProjectContext.Provider>
);
export const useProject = () => useContext(ProjectContext);
